import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#4c9a20',
    },
    secondary: {
      main: '#8a4cae',
    },
  },
});

export default theme;